import React, { FC } from 'react';
import { Paper } from '@mui/material';

import { useTranslate } from 'src/shared/providers';

import { UserPreferencesForm } from './UserPreferencesForm';
import './UserPreferencesSection.styles.scss';

export const UserPreferencesSection: FC = () => {
  const { t } = useTranslate();

  return (
    <Paper id="user-preferences-card" className="h-100 p-4">
      <div className="mb-3">
        <h4 className="pb-0 mb-0">{t('settings.userPreferences')}</h4>
        <label className="text-muted d-block">{t('settings.manageYourUserPreferencesHere')}</label>
      </div>
      <UserPreferencesForm
        classes={{
          wrapper: 'user-preferences-wrapper',
          input: 'd-flex align-items-center flex-wrap user-preferences-input',
        }}
      />
    </Paper>
  );
};
